'use strict';

const appendToUrl = require('../util/appendToUrl');

/**
* @param {Object} scope - Quantity input field DOM element
*/
function changeTrigger(scope) {
    try {
        $(scope).parent().find('.input-Quantity').trigger('change');
    } catch (error) {
        return;
    }
}

/**
* @param {string} val - Currently selected quantity
* @param {string} url - URL to perform AJAX call with.
*/
function checkStoreStock(val, url) {
    let $selectedStoreContainer = $('.js-selected-store-pdp');
    var selectedStoreId = $selectedStoreContainer.data('selected-store-id');

    let urlParams = {
        selectedStoreId: selectedStoreId,
        amount: val
    };
    var checkStockUrl = appendToUrl(url, urlParams);

    $.ajax({
        url: checkStockUrl,
        type: 'get',
        success: function (res) {
            $selectedStoreContainer.html(res.html);

            if (!(res.selectedStore.available || (res.selectedStore.availability && res.selectedStore.availability.type === 'toBeConfirmed'))) {
                $('.add-to-cart').prop('disabled', true);
            } else {
                $('.add-to-cart').prop('disabled', false);
            }
        }
    });
}

module.exports = {
    increaseQuantity: function () {
        $('body').on('change', 'input.input-Quantity', function () {
            // When the input value changes, make sure the user cannot fill in a number higher than the maximum amount.
            var val = $(this).val();
            var maxValue = parseInt($(this).attr('data-maxvalue'), 10);
            const productid = $(this).data('productid');
            const alwaysDisplayWarning = $(this).data('maxvaluewarningalwaysshow');
            const $parentElement = $(this).parents('.js-add-to-cart-group');
            const warningElem = $parentElement.length > 0 ? $parentElement.find('.quantity-limit-text-' + productid)
                : $('.quantity-limit-text-' + productid);
            warningElem.removeClass('text-red-alert');
            warningElem.removeClass('font-weight-bold');

            if ($('html').attr('data-rg-active') === 'true') {
                checkStoreStock(val, $(this).data('stockcheckurl'));
            }

            if (alwaysDisplayWarning === false) {
                warningElem.hide();
            }
            if (val >= maxValue) {
                if (productid) {
                    warningElem.addClass('text-red-alert');
                    warningElem.addClass('font-weight-bold');
                    warningElem.show();
                }
                $(this).val(maxValue);
            }
        });
        $('body').on('click', '.increase-Quantity', function () {
            const inputComponent = $(this).parent().find('.input-Quantity');
            inputComponent.val(function (i, val) {
                return ((val * 1) + 1);
            });
            changeTrigger(this);
        });
    },

    decreaseQuantity: function () {
        $('body').on('click', '.decrease-Quantity', function () {
            var input = $(this).parent().find('.input-Quantity');
            var maxValue = parseInt(input.attr('data-maxvalue'), 10);

            input.val(function (i, val) {
                if (val > 1) {
                    if (val > maxValue) {
                        return maxValue;
                    }
                    return ((val * 1) - 1);
                }
                return (val);
            });
            changeTrigger(this);
        });
    }
};
